import { render, staticRenderFns } from "./LegalPolicies.vue?vue&type=template&id=d012833e&scoped=true&"
import script from "./LegalPolicies.vue?vue&type=script&lang=js&"
export * from "./LegalPolicies.vue?vue&type=script&lang=js&"
import style0 from "./LegalPolicies.vue?vue&type=style&index=0&id=d012833e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d012833e",
  null
  
)

export default component.exports